(function () {
  'use strict';

  var CART_SECTION = 'cart-drawer';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // ── Trust badge SVG icons ────────────────────────────────────────────────
  var SVG_SECURE =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none" stroke="currentColor"' +
    ' stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" width="13" height="13" aria-hidden="true">' +
    '<path d="M8 1.5 2 4v4c0 3.3 2.5 5.9 6 6.7C11.5 13.9 14 11.3 14 8V4Z"/>' +
    '<polyline points="5.5,8.5 7,10 10.5,6.5"/>' +
    '</svg>';

  var SVG_SHIPPING =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 14" fill="none" stroke="currentColor"' +
    ' stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" width="16" height="11" aria-hidden="true">' +
    '<rect x="1" y="1.5" width="11" height="8.5" rx="1"/>' +
    '<path d="M12 4.5h3.5l3 4.5V11H12V4.5Z"/>' +
    '<circle cx="4.5" cy="13" r="1.5"/>' +
    '<circle cx="15.5" cy="13" r="1.5"/>' +
    '</svg>';

  var SVG_RETURNS =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none" stroke="currentColor"' +
    ' stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" width="13" height="13" aria-hidden="true">' +
    '<path d="M2 8a6 6 0 1 0 6-6H2"/>' +
    '<polyline points="2,2.5 2,5.5 5,5.5"/>' +
    '</svg>';

  var TRUST_ICONS = [SVG_SECURE, SVG_SHIPPING, SVG_RETURNS];

  var SVG_VIEW_THUMB =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none" stroke="currentColor"' +
    ' stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" width="14" height="14" aria-hidden="true">' +
    '<rect x="1" y="1" width="6" height="6" rx="0.5"/><rect x="9" y="1" width="6" height="6" rx="0.5"/>' +
    '<rect x="1" y="9" width="6" height="6" rx="0.5"/><rect x="9" y="9" width="6" height="6" rx="0.5"/>' +
    '</svg>';

  var SVG_VIEW_SCROLL =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none" stroke="currentColor"' +
    ' stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" width="14" height="14" aria-hidden="true">' +
    '<rect x="1" y="1.5" width="14" height="4" rx="0.5"/>' +
    '<rect x="1" y="6.5" width="14" height="4" rx="0.5"/>' +
    '<rect x="1" y="11.5" width="14" height="3" rx="0.5"/>' +
    '</svg>';

  // ── Quick view config from theme settings ────────────────────────────────
  var qvCfg = (window.theme && window.theme.quickView) || {};
  var qvStyle = qvCfg.style || 'drawer';
  var trustCfg = qvCfg.trust || [
    { show: true, text: 'Secure checkout' },
    { show: true, text: 'Free shipping' },
    { show: true, text: 'Easy returns' }
  ];

  var drawer   = document.getElementById('qv-drawer');
  var overlay  = document.getElementById('qv-overlay');
  var bodyEl   = document.getElementById('qv-body');
  var closeBtn = document.getElementById('qv-close');
  if (!drawer) return;

  if (qvStyle === 'modal') drawer.classList.add('qv-drawer--modal');

  var triggerEl = null;

  // ── Open / close ────────────────────────────────────────────────────────
  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.classList.add('is-open');
    document.body.classList.add('overflow-hidden');
    window.theme?.trapFocus(drawer);
    closeBtn.focus();
    window.LakiEvents?.emit(window.LakiEvents.EVENTS.DRAWER_OPEN, { drawer });
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
    window.theme?.releaseFocus(drawer);
    if (triggerEl) { triggerEl.focus(); triggerEl = null; }
    window.LakiEvents?.emit(window.LakiEvents.EVENTS.DRAWER_CLOSE, { drawer });
  }

  closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  // ── Helpers ──────────────────────────────────────────────────────────────
  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function sanitizeHtml(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    doc.querySelectorAll('script,iframe,object,embed,base,form').forEach(function(el) { el.remove(); });
    var walker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_ELEMENT);
    var node;
    while ((node = walker.nextNode())) {
      Array.from(node.attributes).forEach(function(attr) {
        if (/^on/i.test(attr.name) || /^(javascript|data|vbscript):/i.test((attr.value || '').trim())) {
          node.removeAttribute(attr.name);
        }
      });
    }
    return doc.body.innerHTML;
  }

  function formatMoney(cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return fmt
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100));
  }

  /* Resize a Shopify CDN image URL: image.jpg → image_900x.jpg */
  function imgUrl(src, size) {
    if (!src) return '';
    if (src.startsWith('//')) src = 'https:' + src;
    return src.replace(/(\.(jpg|jpeg|gif|png|webp))(\?|$)/i, '_' + size + '$1$3');
  }

  function handleFromUrl(url) {
    var m = url.match(/\/products\/([^?#/]+)/);
    return m ? m[1] : null;
  }

  /* Shopify's .js endpoint returns options as either strings or {name, values} objects */
  function optionName(opt) {
    return typeof opt === 'string' ? opt : (opt && opt.name ? opt.name : String(opt));
  }

  /* Strip HTML and truncate to maxLen chars */
  function descExcerpt(html, maxLen) {
    if (!html) return '';
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var text = (tmp.textContent || tmp.innerText || '').trim().replace(/\s+/g, ' ');
    if (text.length <= maxLen) return text;
    return text.slice(0, maxLen).replace(/\s+\S*$/, '') + '…';
  }

  // ── Build drawer HTML from product JSON ───────────────────────────────────
  function buildHTML(product) {
    var firstName = optionName(product.options[0]);
    var hasOnlyDefault = product.options.length === 1 && firstName === 'Title';

    /* Pick best starting variant */
    var variant = product.variants[0];
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].available) { variant = product.variants[i]; break; }
    }

    /* Main image */
    var mainSrc = imgUrl(product.featured_image, '900x');
    var mainSet = mainSrc
      ? (imgUrl(product.featured_image, '900x') + ' 900w,' +
         imgUrl(product.featured_image, '600x') + ' 600w,' +
         imgUrl(product.featured_image, '400x') + ' 400w')
      : '';

    /* Thumbnails */
    var thumbsHtml = '';
    if (product.images.length > 1) {
      thumbsHtml += '<div class="qv-media__thumbs">';
      product.images.slice(0, 5).forEach(function (src, idx) {
        var s900 = imgUrl(src, '900x');
        var sset = s900 + ' 900w,' + imgUrl(src, '600x') + ' 600w,' + imgUrl(src, '400x') + ' 400w';
        thumbsHtml +=
          '<button class="qv-thumb' + (idx === 0 ? ' is-active' : '') + '" type="button"' +
          ' data-src="' + esc(s900) + '" data-srcset="' + esc(sset) + '">' +
          '<img src="' + esc(imgUrl(src, '120x')) + '" alt="" loading="lazy"></button>';
      });
      thumbsHtml += '</div>';
    }

    /* Gallery scroll (all images stacked) */
    var galleryHtml = '';
    var toolbarHtml = '';
    if (product.images.length > 1) {
      galleryHtml = '<div class="qv-gallery">';
      product.images.forEach(function (src, idx) {
        galleryHtml +=
          '<img class="qv-gallery__img" src="' + esc(imgUrl(src, '900x')) + '"' +
          ' alt="' + esc(product.title) + ' – image ' + (idx + 1) + '"' +
          ' loading="' + (idx === 0 ? 'eager' : 'lazy') + '">';
      });
      galleryHtml += '</div>';

      toolbarHtml =
        '<div class="qv-media__toolbar">' +
        '<button class="qv-view-btn qv-view-btn--active" type="button" data-qv-view="thumb" aria-label="Thumbnail view">' + SVG_VIEW_THUMB + '</button>' +
        '<button class="qv-view-btn" type="button" data-qv-view="scroll" aria-label="View all images">' + SVG_VIEW_SCROLL + '</button>' +
        '</div>';
    }

    /* Options */
    var optsHtml = '';
    if (!hasOnlyDefault) {
      product.options.forEach(function (opt, oi) {
        var name = optionName(opt);
        var currentVal = variant.options[oi] || '';
        var seen = {};
        var btnHtml = '';
        product.variants.forEach(function (v) {
          var val = v.options[oi];
          if (seen[val]) return;
          seen[val] = true;
          btnHtml +=
            '<button class="qv-opt-btn' + (val === currentVal ? ' is-active' : '') + '"' +
            ' type="button" data-option-pos="' + (oi + 1) + '" data-option-val="' + esc(val) + '">' +
            esc(val) + '</button>';
        });
        optsHtml +=
          '<div class="qv-option">' +
          '<p class="qv-option__label">' + esc(name) + ': <strong id="qv-opt-current-' + oi + '">' + esc(currentVal) + '</strong></p>' +
          '<div class="qv-option__btns">' + btnHtml + '</div>' +
          '</div>';
      });
    }

    /* Price */
    var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    var priceHtml =
      '<div class="price' + (onSale ? ' price--on-sale' : '') + '">' +
      (onSale ? '<span class="price__compare">' + formatMoney(variant.compare_at_price) + '</span>' : '') +
      '<span class="price__current">' + formatMoney(variant.price) + '</span>' +
      '</div>';

    return (
      '<div class="qv-layout" data-variants="' + esc(JSON.stringify(product.variants)) + '">' +
        '<div class="qv-media">' +
          toolbarHtml +
          '<div class="qv-media__main">' +
            (mainSrc ? '<img class="qv-main-img" src="' + esc(mainSrc) + '" srcset="' + esc(mainSet) + '" sizes="340px" alt="' + esc(product.title) + '" loading="eager">' : '') +
          '</div>' +
          thumbsHtml +
          galleryHtml +
        '</div>' +
        '<div class="qv-info">' +

          /* ── Scrollable area: identity + full description ── */
          '<div class="qv-info__scroll">' +
            (product.vendor ? '<p class="qv-vendor">' + esc(product.vendor) + '</p>' : '') +
            '<h2 class="qv-title">' + esc(product.title) + '</h2>' +
            '<div id="qv-price-wrap">' + priceHtml + '</div>' +
            ((product.description || product.body_html)
              ? '<div class="qv-desc-full">' + sanitizeHtml(product.description || product.body_html) + '</div>'
              : '') +
          '</div>' +

          /* ── Pinned footer: options, qty+ATC, trust, link ── */
          '<div class="qv-info__footer">' +
            optsHtml +
            '<form id="qv-atc-form" action="/cart/add" method="post" enctype="multipart/form-data">' +
              '<input type="hidden" name="id" id="qv-variant-id" value="' + variant.id + '">' +
              '<div class="qv-add-row">' +
                '<div class="qv-qty">' +
                  '<button class="qv-qty-btn" type="button" data-qty-step="-1" aria-label="Decrease quantity">−</button>' +
                  '<input class="qv-qty-input" type="number" name="quantity" value="1" min="1" max="99" aria-label="Quantity">' +
                  '<button class="qv-qty-btn" type="button" data-qty-step="1" aria-label="Increase quantity">+</button>' +
                '</div>' +
                (window.LakiATC
                  ? '<div class="pt-atc-wrap" data-atc-style="trust_loop">' +
                      '<button id="qv-atc-btn" class="pt-atc-btn" type="button"' +
                      ' data-atc-main data-add-to-cart' +
                      ' data-form-id="qv-atc-form"' +
                      ' data-product-title="' + esc(product.title) + '"' +
                      ' data-state="' + (variant.available ? 'idle' : 'sold-out') + '"' +
                      (!variant.available ? ' disabled' : '') + '>' +
                        '<span class="pt-atc__ghost" aria-hidden="true">Add to cart</span>' +
                        '<span class="pt-atc__state pt-atc__state--idle">Add to cart</span>' +
                        '<span class="pt-atc__state pt-atc__state--sold-out">Sold out</span>' +
                        '<span class="pt-atc__state pt-atc__state--loading" aria-hidden="true">' +
                          '<span class="pt-atc__spinner"></span>Adding…</span>' +
                        '<span class="pt-atc__state pt-atc__state--success" aria-hidden="true">Added!</span>' +
                        '<span class="pt-atc__state pt-atc__state--error" aria-hidden="true">Error – try again</span>' +
                        '<span class="pt-atc__state pt-atc__state--retry" aria-hidden="true">Try Again</span>' +
                      '</button>' +
                      '<div class="pt-atc__sr" aria-live="polite" aria-atomic="true"></div>' +
                    '</div>'
                  : '<button id="qv-atc-btn" class="button" type="submit" data-add-to-cart' +
                      (!variant.available ? ' disabled' : '') + '>' +
                      (variant.available ? 'Add to cart' : 'Sold out') +
                    '</button>') +
              '</div>' +
            '</form>' +
            (function () {
              var parts = [];
              trustCfg.forEach(function (item, i) {
                if (item.show === false) return;
                parts.push('<span class="qv-trust__item">' + TRUST_ICONS[i] + esc(item.text) + '</span>');
              });
              return parts.length
                ? '<div class="qv-trust">' + parts.join('<span class="qv-trust__sep" aria-hidden="true">·</span>') + '</div>'
                : '';
            })() +
            '<a class="qv-full-link" href="/products/' + esc(product.handle) + '">' +
              'View full details ' +
              '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" width="12" height="12" aria-hidden="true"><path d="M3 8h10M9 4l4 4-4 4"/></svg>' +
            '</a>' +
          '</div>' +

        '</div>' +
      '</div>'
    );
  }

  // ── Load product via /products/handle.js ─────────────────────────────────
  function loadProduct(productUrl, trigger) {
    triggerEl = trigger;
    bodyEl.innerHTML = '<div class="quick-add-loading" aria-hidden="true"></div>';
    openDrawer();

    var handle = handleFromUrl(productUrl);
    if (!handle) { showError(productUrl); return; }

    fetch(root + 'products/' + handle + '.js')
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (product) {
        bodyEl.innerHTML = buildHTML(product);
        initContent();
      })
      .catch(function (e) {
        showError(productUrl);
        console.error('[laki quick-view]', e);
      });
  }

  function showError(url) {
    bodyEl.innerHTML =
      '<div style="padding:2rem;text-align:center">' +
      '<p style="margin-bottom:1rem">Could not load product preview.</p>' +
      '<a class="button button--secondary" href="' + esc(url) + '">View product</a>' +
      '</div>';
  }

  // ── Init interactive content ─────────────────────────────────────────────
  function initContent() {
    /* View toggle: thumbnail ↔ scroll gallery */
    bodyEl.querySelectorAll('[data-qv-view]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var isScroll = btn.dataset.qvView === 'scroll';
        var media = bodyEl.querySelector('.qv-media');
        if (media) media.classList.toggle('qv-media--gallery', isScroll);
        bodyEl.querySelectorAll('[data-qv-view]').forEach(function (b) {
          b.classList.toggle('qv-view-btn--active', b === btn);
        });
      });
    });

    /* Thumbnails */
    bodyEl.querySelectorAll('.qv-thumb').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var img = bodyEl.querySelector('.qv-main-img');
        if (img) {
          img.src = btn.dataset.src;
          img.srcset = btn.dataset.srcset || '';
          img.removeAttribute('sizes');
        }
        bodyEl.querySelectorAll('.qv-thumb').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });

    /* Variants */
    var layout = bodyEl.querySelector('[data-variants]');
    if (!layout) return;

    var variants;
    try { variants = JSON.parse(layout.dataset.variants); } catch (e) { return; }

    var startId = parseInt((bodyEl.querySelector('#qv-variant-id') || {}).value || '0', 10);
    var startV  = variants.find(function (v) { return v.id === startId; }) || variants[0];
    var selected = startV.options.slice();

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      }) || null;
    }

    function updateUI(variant) {
      if (!variant) return;

      var idInput = bodyEl.querySelector('#qv-variant-id');
      if (idInput) idInput.value = variant.id;

      var pw = bodyEl.querySelector('#qv-price-wrap');
      if (pw) {
        var sale = variant.compare_at_price && variant.compare_at_price > variant.price;
        pw.innerHTML =
          '<div class="price' + (sale ? ' price--on-sale' : '') + '">' +
          (sale ? '<span class="price__compare">' + formatMoney(variant.compare_at_price) + '</span>' : '') +
          '<span class="price__current">' + formatMoney(variant.price) + '</span>' +
          '</div>';
      }

      var atcBtn = bodyEl.querySelector('#qv-atc-btn');
      if (atcBtn) {
        atcBtn.disabled = !variant.available;
        if (atcBtn.hasAttribute('data-atc-main')) {
          atcBtn.dataset.state = variant.available ? 'idle' : 'sold-out';
        } else {
          atcBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
        }
      }

      if (variant.featured_image && variant.featured_image.src) {
        var img = bodyEl.querySelector('.qv-main-img');
        if (img) {
          img.src = imgUrl(variant.featured_image.src, '900x');
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
        }
      }
    }

    bodyEl.querySelectorAll('.qv-opt-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pos = parseInt(btn.dataset.optionPos, 10) - 1;
        var val = btn.dataset.optionVal;
        selected[pos] = val;

        var group = btn.closest('.qv-option__btns');
        if (group) group.querySelectorAll('.qv-opt-btn').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');

        var lbl = bodyEl.querySelector('#qv-opt-current-' + pos);
        if (lbl) lbl.textContent = val;

        updateUI(findVariant(selected));
      });
    });

    /* Quantity +/- */
    bodyEl.querySelectorAll('[data-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.closest('.qv-qty').querySelector('.qv-qty-input');
        if (!input) return;
        var next = Math.max(1, Math.min(99, parseInt(input.value || 1, 10) + parseInt(btn.dataset.qtyStep, 10)));
        input.value = next;
      });
    });

    var form = bodyEl.querySelector('#qv-atc-form');
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(form); });
  }

  // ── Add to cart ──────────────────────────────────────────────────────────
  function addToCart(form) {
    var btn = bodyEl.querySelector('#qv-atc-btn');
    var orig = btn ? btn.textContent : 'Add to cart';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || 'Unable to add item.');
          return data;
        });
      })
      .then(function () {
        return Promise.all([
          fetch(root + 'cart.js').then(function (r) { return r.json(); }),
          fetch(root + '?sections=' + CART_SECTION).then(function (r) { return r.json(); })
        ]);
      })
      .then(function (results) {
        var cartData = results[0];
        var sectionHtml = results[1][CART_SECTION];
        if (typeof cartData.item_count === 'number') {
          document.querySelectorAll('[data-cart-count], .cart-count-bubble').forEach(function (el) {
            el.textContent = cartData.item_count;
          });
        }
        if (sectionHtml) {
          var wrapper = document.getElementById('shopify-section-' + CART_SECTION);
          if (wrapper) wrapper.outerHTML = sectionHtml;
        }
        if (btn) btn.textContent = 'Added!';
        setTimeout(function () {
          closeDrawer();
          var cartEl = document.querySelector('laki-cart');
          if (cartEl && typeof cartEl.open === 'function') cartEl.open();
        }, 500);
      })
      .catch(function (e) {
        if (btn) {
          btn.disabled = false;
          btn.textContent = 'Error – try again';
          setTimeout(function () { btn.textContent = orig; }, 2000);
        }
        console.error('[laki quick-view ATC]', e);
      });
  }

  // ── Trigger ──────────────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-view]');
    if (!btn || !btn.dataset.quickView) return;
    e.preventDefault();
    e.stopPropagation();
    loadProduct(btn.dataset.quickView, btn);
  });
})();
